module.exports = __webpack_public_path__ + "media/images/new-ui-images/note-4a1b97e1e77cb4db7e41b8155a42d8a4.svg";